import React from 'react';
import {
  FaUserCog,
  FaClipboardList,
  FaCogs,
  FaMicroscope
} from 'react-icons/fa';

const requiredSteps = [
  {
    key: 'clientsetup',
    title: 'Step 1: Client Setup',
    description:
      'Add and configure clients including Short Calls Threshold, and Passing Score.',
    icon: <FaUserCog className="text-3xl text-blue-600" />,
    highlight: 'required'
  },
  {
    key: 'clientscorecard',
    title: 'Step 2: Client Scorecard',
    description:
      'Assign QA scoring categories and weights for each client. You are done!',
    icon: <FaClipboardList className="text-3xl text-yellow-500" />,
    highlight: 'required'
  }
];

const optionalSteps = [
  {
    key: 'prompts',
    title: 'Optional: Prompt Management',
    description:
      'Define prompt questions used during transcript evaluation. Only needed if you are creating new questions.',
    icon: <FaCogs className="text-3xl text-purple-600" />,
    highlight: 'optional'
  },
  {
    key: 'transcribe',
    title: 'Optional: QA Prompt Evaluator',
    description:
      'Test prompts against transcripts and generate AI insights. Use only if creating or testing new questions.',
    icon: <FaMicroscope className="text-3xl text-green-600" />,
    highlight: 'optional'
  }
];

const StepCard = ({ step, onSelectTab }) => (
  <div
    className={`${
      step.highlight === 'required' ? 'bg-blue-50 border-blue-600' : 'bg-gray-50 border-gray-300'
    } shadow-lg rounded-lg p-6 text-center w-full sm:w-96 hover:shadow-2xl transition-transform transform hover:-translate-y-1 border-2`}
  >
    <div className="mb-4">{step.icon}</div>
    <h2 className="text-xl font-bold text-gray-800 mb-2">{step.title}</h2>
    <p className="text-sm text-gray-600 mb-4">{step.description}</p>
    <button
      onClick={() => onSelectTab(step.key)}
      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
    >
      Go to {step.title.replace(/^Step \\d+: |Optional: /, '')}
    </button>
  </div>
);

const LandingPage = ({ onSelectTab }) => (
  <div className="p-10 bg-gray-100 min-h-screen">
    <h1 className="text-3xl font-bold text-center mb-10 text-blue-800">
      Welcome to Yaqeen GenAI QA Monitor™
    </h1>

    <div className="flex flex-wrap justify-center gap-6 mb-10">
      {requiredSteps.map((step) => (
        <StepCard key={step.key} step={step} onSelectTab={onSelectTab} />
      ))}
    </div>

    <div className="flex flex-wrap justify-center gap-6">
      {optionalSteps.map((step) => (
        <StepCard key={step.key} step={step} onSelectTab={onSelectTab} />
      ))}
    </div>
  </div>
);

export default LandingPage;

